export default {
  title: "Gerätestatistiken",
  description: "Kiosk-Produktanalysen aus PostHog (Produktion).",
  iframeTitle: "PostHog-Dashboard Gerätestatistiken",
  rangeLabel: "Zeitraum",
  ranges: {
    last7Days: "Letzte 7 Tage",
    last30Days: "Letzte 30 Tage",
    last90Days: "Letzte 90 Tage",
    thisMonth: "Dieser Monat",
    lastMonth: "Letzter Monat",
  },
} as const;
